import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const useBusinessModelGroupsApiQuery = () => {
    const { data, loading, error, refetch } = useApiQuery('/api/businessmodelgroups', 'get');
    return { data, loading, error, refetch };
};
